import React from 'react';
import { ScaleIcon, ArrowRightIcon } from 'lucide-react';
import { costRows } from '../data/content';
export function CostSection() {
  return <section aria-labelledby="cost" className="bg-surface px-5 py-20 sm:py-24" data-id="element-43" data-mp="9cpy6lqz2w3c">
      <div className="mx-auto max-w-5xl" data-id="element-44" data-mp="4jwtfxvi7nr9">
        <h2 id="cost" className="flex flex-col items-center gap-3 text-center text-3xl font-black uppercase leading-tight text-white sm:text-4xl" data-id="element-45" data-mp="3vriv5kynxg5h">
          <ScaleIcon className="h-10 w-10 text-sun" aria-hidden="true" data-id="element-46" data-mp="3qt7kx94gh3mq" />
          ¿Cuánto cuesta seguir sin tenerlo?
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl border border-line bg-ink" data-id="element-47" data-mp="3msxgw2084nai">
          <div className="hidden grid-cols-[1fr_40px_1fr] gap-4 border-b border-line px-6 py-4 text-xs font-black uppercase tracking-widest md:grid" data-id="element-48" data-mp="3hrzzhrn1fxa2">
            <span className="text-muted" data-id="element-49" data-mp="1g0wlcsdxw0kr">Sin MegaPack</span>
            <span data-id="element-50" data-mp="1fyae6tuynn32" />
            <span className="text-coral" data-id="element-51" data-mp="1b1a7cgqaegaw">El costo cotidiano</span>
          </div>
          <ul data-id="element-52" data-mp="1az7cnje6vyzu">
            {costRows.map(r => <li key={r.without} className="grid gap-2 border-b border-line px-6 py-5 last:border-b-0 md:grid-cols-[1fr_40px_1fr] md:items-center md:gap-4" data-id="element-53" data-mp="p6idk0x8uwwc">
                <p className="text-base font-bold text-white" data-id="element-54" data-mp="f9dq7xrnwvdy">{r.without}</p>
                <ArrowRightIcon className="hidden h-5 w-5 text-line md:block" aria-hidden="true" data-id="element-55" data-mp="fbi3h6bgb6qw" />
                <p className="text-base text-coral" data-id="element-56" data-mp="kakxlvpw7sk3">{r.cost}</p>
              </li>)}
          </ul>
        </div>

        <div className="mt-14 text-center" data-id="element-57" data-mp="1cx5ypnw67j0u">
          <p className="text-3xl font-black uppercase leading-tight text-brand sm:text-5xl" data-id="element-58" data-mp="1cvul6wcxawwj">La próxima tarde puede ser diferente.</p>
          <p className="mt-4 text-lg font-semibold text-cream/90" data-id="element-59" data-mp="y65g4q1pm8qz">Menos búsquedas. Menos improvisación. Más momentos para compartir.</p>
        </div>
      </div>
    </section>;
}